import { Typography } from "@mui/material";
import * as React from "react";
import { useEffect, useState } from "react";
import {
  Datagrid,
  downloadCSV,
  List,
  TextField,
  useListContext,
  useRecordContext,
} from "react-admin";
import {
  getCachedMenuStats,
  isMenuStatsCacheExpired,
  preloadMenuStats,
} from "../layout/PreloadMenuStats";
import CustomDateField from "../unit/CustomDateField";
import HmPageHeaderTitle from "../unit/HmPageHeaderTitle";
import PostPagination from "../unit/PostPagination";
import { ShowListTotal } from "../unit/ShowListTotal";
import useNotify from "../unit/useNotify";
import CustomerIdLinkField from "./CustomerIdLinkField";
import CustomerLinkField from "./CustomerLinkField";
import CustomerListActions from "./CustomerListActions";
import { getCustomerListFilters } from "./CustomerListFilters";
import CustomerYearListAside from "./CustomerYearListAside";
import { hmLightTheme } from "../themes/hmTheme";
import CustomLoading from "../unit/CustomLoading";
import formatDate from "../unit/formatDate";
import getFiltersFromURL from "../unit/getFiltersFromURL";
import HmLoading from "../unit/HmLoading";
import NoResults from "../unit/NoResults";
import NoPermission from "../unit/NoPermission";
const CustomerAccountType = () => {
  const record = useRecordContext();

  let accounttype = "";
  if (record) {
    if (record.isVerify != 1) {
      accounttype = "Unverified";
    }
    if (
      record.isVerify == 1 &&
      (record.loansnum == 0 || record.loansnum == null) &&
      (record.appnum == 0 || record.appnum == null)
    ) {
      accounttype = "New Sign-Up";
    } else {
      if (record.loansnum > 0) {
        if (record.loanActiveNum > 0) {
          accounttype = "Borrowing";
        }
        if (record.loanChargedOffNum > 0 && record.loanActiveNum == 0) {
          accounttype = "Charged-Off";
        }
        if (
          record.loanPaidOffNum > 0 &&
          record.loanChargedOffNum == 0 &&
          record.loanActiveNum == 0
        ) {
          accounttype = "Paid-Off";
        }
      } else {
        if (record.appnum > 0) {
          if (record.appInProgressNum > 0) {
            accounttype = "New Applicant";
          }
          if (record.appExpiredNum > 0 && record.appInProgressNum == 0) {
            accounttype = "Past Applicant";
          }
          if (
            record.appAccountApprovedNum > 0 &&
            record.appInProgressNum == 0 &&
            record.appExpiredNum == 0
          ) {
            accounttype = "Account Only";
          }
        }
      }
    }
  }

  return <>{accounttype}</>;
};

const CustomerListTitle = () => {
  const listContext = useListContext();
  const { filterValues } = listContext;
  return (
    <>
      {filterValues.status == "Unverified" && (
        <HmPageHeaderTitle
          title="Unverified"
          totalNumber={<ShowListTotal onlyShowNumber={true} />}
        />
      )}
      {filterValues.status == "New Sign-Up" && (
        <HmPageHeaderTitle
          title="New Sign-Up"
          totalNumber={<ShowListTotal onlyShowNumber={true} />}
        />
      )}
      {filterValues.status == "Borrowing" && (
        <HmPageHeaderTitle
          title="Borrowing"
          totalNumber={<ShowListTotal onlyShowNumber={true} />}
        />
      )}
      {filterValues.status == "Charged-Off" && (
        <HmPageHeaderTitle
          title="Charged-Off"
          totalNumber={<ShowListTotal onlyShowNumber={true} />}
        />
      )}
      {filterValues.status == "Paid-Off" && (
        <HmPageHeaderTitle
          title="Paid-Off"
          totalNumber={<ShowListTotal onlyShowNumber={true} />}
        />
      )}
      {filterValues.status == "New Applicant" && (
        <HmPageHeaderTitle
          title="New Applicant"
          totalNumber={<ShowListTotal onlyShowNumber={true} />}
        />
      )}
      {filterValues.status == "Past Applicant" && (
        <HmPageHeaderTitle
          title="Past Applicant"
          totalNumber={<ShowListTotal onlyShowNumber={true} />}
        />
      )}
      {filterValues.status == "Account Only" && (
        <HmPageHeaderTitle
          title="Account Only"
          totalNumber={<ShowListTotal onlyShowNumber={true} />}
        />
      )}
    </>
  );
};

const CustomrDefaultList = ({ ...props }) => {
  const { total, isFetching, isLoading } = useListContext();
  const listContext = useListContext();
  const { filterValues } = listContext;
  return (
    <>
      <Datagrid
        optimized
        rowClick={false}
        size="small"
        empty={false}
        className="hm-list-datagrid"
        id="table-customers"
        sx={{
          ".MuiTableCell-root": {
            padding: "6px",
          },
          ".RaDatagrid-headerCell:first-child": {
            borderTopLeftRadius: "0px",
          },
          ".RaDatagrid-headerCell:last-child": {
            borderTopRightRadius: "0px",
          },
          "& .column-groups": {
            md: { display: "none" },
            lg: { display: "table-cell" },
          },
          "& .Mui-active": {
            color: "gray",
          },

          "& .MuiTableSortLabel-root": {
            padding: "5px",
          },
          "& .RaDatagrid-headerCell": {
            color: "gray",
            fontSize: "1rem",
            backgroundColor: "#edf4fb",
            wordWrap: "break-word",
          },
          "& .MuiTableCell-paddingCheckbox": {
            display: "none",
          },
          "& .MuiTableCell-root.column-appnum": {
            minWidth: "100px",
            width: "100px",
            maxWidth: "100px",
            textAlign: "center",
          },
          "& .MuiTableCell-root.column-loansnum": {
            minWidth: "100px",
            width: "100px",
            maxWidth: "100px",
            textAlign: "center",
          },
          "& .MuiTableCell-root.column-plaidAccount": {
            minWidth: "100px",
            width: "100px",
            maxWidth: "100px",
            textAlign: "center",
          },
          "& .MuiTableCell-root.column-plaidAccount_ach": {
            minWidth: "100px",
            width: "100px",
            maxWidth: "100px",
            textAlign: "center",
          },
          "& .MuiTableCell-root.column-signup_time": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
          },
          "& .MuiTableCell-root.column-last_login_time": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
          },
          "& .MuiTableCell-root.column-zip": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdDateWidth,
          },
          "& .MuiTableCell-root.column-state": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdSmallWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdSmallWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdSmallWidth,
          },
          "& .MuiTableCell-root.column-iApplicationId": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAppIdWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdAppIdWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdAppIdWidth,
          },
          "& .MuiTableCell-root.column-sLoanNum": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdLoanIdWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdLoanIdWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdLoanIdWidth,
          },
          "& .MuiTableCell-root.column-iUserId": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdUserIdWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdUserIdWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdUserIdWidth,
          },
          "& .MuiTableCell-root.column-userId": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdUserIdWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdUserIdWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdUserIdWidth,
          },
          "& .MuiTableCell-root.column-userName": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
          "& .MuiTableCell-root.column-sCouponCode ": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
          "& .MuiTableCell-root.column-sEmail": {
            minWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            width: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            maxWidth: hmLightTheme?.palette?.otherSpacing?.tableTdTextWidth,
            wordBreak: "break-word",
            overflowX: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
          },
        }}
      >
        <CustomerIdLinkField label="User #" source="userId" />
        <TextField source="sCouponCode" label="Sign Up Channel" />
        {/* <CustomerAccountType label="Account Type" /> */}
        <CustomerLinkField label="Customer Name" source="userName" />
        {/* <TextField label="Email" source="sEmail" /> */}
        {/* <TextField source="sMobile" label="Mobile" cellClassName="numericText" /> */}
        <CustomDateField
          source="signup_time"
          label="Sign Up"
          onlyShowDate={false}
          oldFormat="mm-dd-yyyy"
          cellClassName="dateText"
        />
        <CustomDateField
          source="last_login_time"
          label="Last Login"
          onlyShowDate={false}
          cellClassName="dateText"
        />
        <TextField
          source="appnum"
          label="Applications"
          className="numtd"
          cellClassName="numericText"
        />
        <TextField
          source="loansnum"
          label="Loans"
          className="numtd"
          cellClassName="numericText"
        />
        {(filterValues.status == "Borrowing" ||
          filterValues.status == "All Borrowing") && (
          <TextField
            source="loanActiveNum"
            label="Number of Active Loans"
            cellClassName="numericText"
          />
        )}
        {filterValues.status == "Paid-Off" && (
          <TextField
            source="loanPaidOffNum"
            label="Number of Paid-Off Loans"
            cellClassName="numericText"
          />
        )}
        {filterValues.status == "Charged-Off" && (
          <TextField
            source="loanChargedOffNum"
            label="Number of Charged-Off Loans"
            cellClassName="numericText"
          />
        )}

        {/* <TextField
          source="plaidAccount"
          label="Financial Accounts"
          className="numtd"
          cellClassName="numericText"
          sortable={false}
        />
        <TextField
          source="plaidAccount_ach"
          label="Payment Accounts"
          cellClassName="numericText"
          sortable={false}
        /> */}
        {/* state, zip */}
        <TextField source="state" label="State" />
        <TextField source="zip" label="Zip" cellClassName="numericText" />
      </Datagrid>
      <CustomLoading />
    </>
  );
};
const customCustomerTypeExporter = (records: any) => {
  let filterStatus = "";
  if (records.length > 0) {
    filterStatus = records[0].sStatus;
  }
  let data = [];
  let title = {};

  if (filterStatus == "xxx") {
  } else {
    data = records.map((record: any) => {
      const {
        id,
        sCouponCode,
        userName,
        signup_time,
        last_login_time,
        appnum,
        loansnum,
        plaidAccount,
        plaidAccount_ach,
        state,
        zip,
      } = record;
      return {
        id: id,
        sCouponCode: sCouponCode,
        userName: userName,
        signup_time: formatDate(signup_time, "yyyy-mm-dd"),
        last_login_time: formatDate(last_login_time, "yyyy-mm-dd"),
        appnum: appnum,
        loansnum: loansnum,
        plaidAccount: plaidAccount,
        plaidAccount_ach: plaidAccount_ach,
        state: state,
        zip: zip,
      };
    });
    title = {
      id: "User #",
      sCouponCode: "Sign Up Channel",
      userName: "Customer Name",
      signup_time: "Sign Up",
      last_login_time: "Last Login",
      appnum: "Applications",
      loannum: "Loans",
      plaidAccount: "Financial Accounts",
      plaidAccount_ach: "Payment Accounts",
      state: "State",
      zip: "Zip",
    };
  }

  return {
    title: title,
    data: data,
    filterStatus: filterStatus,
  };
};
function customCustomerFilterText(
  filter_status: string,
  filter_curStatus: string
) {
  let filterText = "_";
  if (filter_status == "signUp2025_campaigns") {
    filterText += "Sign-Ups in 2025 to Date_Campaigns";
  } else if (filter_status == "signUp2025_counselors") {
    filterText += "Sign-Ups in 2025 to Date_Counselors";
  } else if (filter_status == "signUp2025_direct") {
    filterText += "Sign-Ups in 2025 to Date_Direct";
  } else if (filter_status == "signUp2025_other") {
    filterText += "Sign-Ups in 2025 to Date_Other";
  } else if (filter_status == "signUp2024_campaigns") {
    filterText += "Sign-Ups in 2024 to Date_Campaigns";
  } else if (filter_status == "signUp2024_counselors") {
    filterText += "Sign-Ups in 2024 to Date_Counselors";
  } else if (filter_status == "signUp2024_direct") {
    filterText += "Sign-Ups in 2024 to Date_Direct";
  } else if (filter_status == "signUp2024_other") {
    filterText += "Sign-Ups in 2024 to Date_Other";
  } else if (filter_status == "signUp2023_campaigns") {
    filterText += "Sign-Ups in 2023 to Date_Campaigns";
  } else if (filter_status == "signUp2023_counselors") {
    filterText += "Sign-Ups in 2023 to Date_Counselors";
  } else if (filter_status == "signUp2023_direct") {
    filterText += "Sign-Ups in 2023 to Date_Direct";
  } else if (filter_status == "signUp2023_other") {
    filterText += "Sign-Ups in 2023 to Date_Other";
  } else if (filter_status == "signUp2022_campaigns") {
    filterText += "Sign-Ups in 2022 to Date_Campaigns";
  } else if (filter_status == "signUp2022_counselors") {
    filterText += "Sign-Ups in 2022 to Date_Counselors";
  } else if (filter_status == "signUp2022_direct") {
    filterText += "Sign-Ups in 2022 to Date_Direct";
  } else if (filter_status == "signUp2022_other") {
    filterText += "Sign-Ups in 2022 to Date_Other";
  }
  return filterText;
}
const customCustomerExporter = (records: any, fetchRelatedRecords: any) => {
  const filterData = customCustomerTypeExporter(records);

  //{{{
  const currentFilters = getFiltersFromURL();
  const filter_status = currentFilters?.status;
  const filter_curStatus = currentFilters?.curStatus;
  // console.log("currentFilters in exporter:", currentFilters);
  const otherFilters = { ...currentFilters };
  delete otherFilters.status;
  delete otherFilters.curStatus;
  delete otherFilters.filterRemainingterm;
  const filterString = Object.entries(otherFilters)
    .map(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        if (key == "id") {
          key = "User #";
        }
        return `[${key} is "${value}"]`;
      }
      return "";
    })
    .filter(Boolean)
    .join("");

  console.log("Filter string:", filterString);
  ///}}}

  let csvTitle = filterData.title;
  let data = filterData.data;
  let filterStatus = filterData.filterStatus;
  const csvData = [{ ...csvTitle }, ...data];
  const csvDataStr = csvData.map((row) => Object.values(row).join(","));
  let filename = "Customers";
  filename += customCustomerFilterText(filter_status, filter_curStatus);
  if (filterString) {
    csvDataStr.push("");
    csvDataStr.push("Filters Applied:" + filterString);
  }
  downloadCSV(csvDataStr.join("\n"), filename);
};

const CustomerYearList = () => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const [record, setRecord] = React.useState<{ total: number } | null>(null);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const permissions =
    localStorage.getItem("bbaccess")?.toString().split(",") || [];
  if (!permissions.includes("personal_customers")) {
    return <NoPermission />;
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        if (isMenuStatsCacheExpired("customer", 3600000)) {
          await preloadMenuStats("customer");
        }
        const data = getCachedMenuStats("customer");
        setTotal(data ? data.data : 0);
      } catch (error) {
        console.error("Failed to load customer stats:", error);
        setTotal(0);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // console.log("CustomerYearList total:", total);

  return (
    <>
      <List
        actions={<CustomerListActions />}
        filters={getCustomerListFilters()}
        aside={<CustomerYearListAside totalData={total} />}
        sort={{ field: "created_at", order: "DESC" }}
        exporter={customCustomerExporter}
        sx={{
          width: "100%",
          borderRadius: "0px",
          "& .MuiCard-root": {
            borderRadius: "0px",
          },
          "& .RaList-actions form": {
            flex: "0 1 350%",
          },
          "& .RaList-actions form .filter-field .MuiInputBase-input": {
            width: "230px",
          },
          "& .RaList-actions .RaFilterForm-filterFormInput:first-child .MuiInputBase-root::before":
            {
              display: "none",
            },
          "& .RaList-actions .filter-field:first-child .MuiFormControl-root": {
            marginLeft: 0,
          },
        }}
        empty={
          <Typography className="no-results">
            <NoResults />
          </Typography>
        }
        emptyWhileLoading={false}
        loading={<HmLoading />}
        pagination={<PostPagination />}
        perPage={25}
      >
        <CustomrDefaultList />
      </List>
    </>
  );
};

export default CustomerYearList;
